import React from 'react';

type Props = {
    className?  : string
    field       : any
    disabled?   : boolean

    onClick     : callback

    children?   : any
}

export default function FieldUser_FormValueEmpty(props: Props) {

    // no value option is used here at least for automation crete task/subtask when NOT assign is null value

    const classes = Classes("ui5-txt-default", "ui5-field-form-editable", "dropdown-form", "h-36", props.className, {
        "is-disabled": props.disabled
    })

    const valueClasses = Classes({
        "ui5-txt-default"           : !props.disabled,
        "ui5-txt-no-accent-default" : props.disabled
    })

    if (props.field.noValueOption) {

        return (
            <React.Fragment>
                <div className  = {classes}
                     onClick    = {props.onClick}>

                    {_.get(props.field.components, 'ValueIcon', false)}

                    <span className = {valueClasses}>
                        {props.field.noValueOptionLabel}
                    </span>

                </div>

                {props.children}

            </React.Fragment>
        )

    } else {

        const classes = Classes("ui5-txt-no-accent-default", "ui5-field-form-editable", "dropdown-form", "h-36", props.className)

        return (
            <React.Fragment>
                <div className  = {classes}
                     onClick    = {props.onClick}>

                    {_.get(props.field.components, 'ValueIcon', false)}

                    {props.field.placeholder}

                </div>

                {props.children}

            </React.Fragment>
        )
    }
}
